import { formatDate } from '@/common/utils/formatters'
import { missionStatusStrategy } from '@/features/missions/constants/missionOptions.constant'
import { Mission } from '@/features/missions/types/mission.type'

interface LinkedMissionCardProps {
  mission: Mission
}

export default function LinkedMissionCard({mission}: LinkedMissionCardProps) {
  const formattedIsRepeatable = `Até no max ${mission?.maximum_completions_per_user}x`

  return (
    <div className='flex flex-col w-full text-start gap-y-2 bg-white-100 border border-transparent rounded-lg p-4'>
      <div className="flex w-full flex-col">
        <p className="w-full text-base font-bold">{mission.display_name}</p>
        <p className="w-full text-sm">{mission.description}</p>
      </div>

      {mission?.establishment && (
        <div className="flex w-full flex-col">
          <p className="text-xs font-light italic">Estabelecimento</p>
          <p className="w-full text-sm font-bold">{mission.establishment?.display_name}</p>
        </div>
      )}

      <div className='flex w-full items-center justify-between'>
        <div className="flex w-full flex-col">
          <p className="text-xs font-light italic">Status</p>
          <p className="w-full text-sm font-bold">{mission?.status ? missionStatusStrategy[mission?.status as keyof typeof missionStatusStrategy] : '--'}</p>
        </div>

        <div className="flex w-full flex-col">
          <p className="text-xs font-light italic">Expiração</p>
          <p className="w-full text-sm font-bold">{mission?.available_until ? formatDate(new Date(mission.available_until)) : '--'}</p>
        </div>
      </div>

      <div className="flex w-full flex-col">
        <p className="text-xs font-light italic">Repetível</p>
        <p className="w-full text-sm font-bold">{formattedIsRepeatable}</p>
      </div>
    </div>
  )
}
